import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TenantConfService } from 'src/app/services/tenant-conf.service';

@Directive({
  selector: '[languageRouter]',
  host: {
    '[style.cursor]': '"pointer"',
  },
})
export class LanguageRouterDirective {
  @Input() languageRouter: any;

  @HostListener('click', ['$event.target'])
  onClick(btn) {
    const language = this.tenantService.getLanguage();
    this.router.navigate([
      language,
      ...this.languageRouter.map((r: string, index) => (index === 0 ? this.translate.instant(`ROUTES.${r.toUpperCase()}`) : r)),
    ]);
  }

  constructor(private router: Router, private tenantService: TenantConfService, private translate: TranslateService) {}
}
